import React from "react";
import styles from "./HomeFour.module.css";
import destination from "../../assets/images/destination 1.svg";
import passport from "../../assets/images/passport 1.svg";
import visa from "../../assets/images/visa 1.svg";

import {FaLessThan} from 'react-icons/fa';
import {FaGreaterThan} from 'react-icons/fa'

import stars from '../../assets/images/Star.svg';
import cont from '../../assets/images/cont.png'

const data1 = [
  {
    dark: true,
    name: "Choose Destination",
    image: destination,
    des:
      "Choose destination country, completeour easy online application and pay with your card or bank transfer",
  },
  {
    dark: false,
    name: "Submit all documents",
    image: passport,
    des:
      "Submit all documents required by the embassy for your visa electronically and we will do the running arounds.",
  },
  {
    dark: false,
    name: "Receive travel document",
    image: visa,
    des:
      "We will notify once a decision is made on your application by the embassy. we will send all documents to you via courier.",
  },
];


const data2=[
  {
    name: "Great Design!",
    des: "I am very helped in making a website and business development that makes the product that I have to have a quality for use by the user",
    rname: "Mang Oleh",
    rdes: "Product Designer",
  },
  {
    name: "Great Design!",
    des: "I am very helped in making a website and business development that makes the product that I have to have a quality for use by the user",
    rname: "Mang Oleh",
    rdes: "Product Designer",
  },
  {
    name: "Great Design!",
    des: "I am very helped in making a website and business development that makes the product that I have to have a quality for use by the user",
    rname: "Mang Oleh",
    rdes: "Product Designer",
  },
]


export default function HomeFour() {
  return (
    <div className={styles.main}>
      <div className={styles.howItWorks}>
        <h1 className={styles.heading1}>How it works</h1>
        <p className={styles.pera}>
          Our visa application is very simple and seamless. Apply now in three
          simple steps.
        </p>
        <div className={styles.cards1}>
          {data1.map((value, index) => (
            <div className={value.dark ? styles.card1d : styles.card1} key={index}>
              <img
                src={value.image}
                alt={value.name}
                className={value.dark ? styles.image1d : styles.image1}
              />
              <div className={styles.mobileW}>
                <h1 className={value.dark ? styles.name1d : styles.name1}>
                  {value.name}
                </h1>
                <p className={value.dark ? styles.des1d : styles.des1}>
                  {value.des}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className={styles.aboutUs}>
        <div className={styles.mobilec}>
          <h1 className={styles.heading2}>What Are People Saying About Us</h1>
        </div>
          {/* <div className={styles.signs}>
              <FaLessThan size={28}    className={styles.icons}  />
              <FaGreaterThan size={28} className={styles.icons} />
          </div> */}
          <div className={styles.cards2}>
          {data2.map((value, index) => (
            <div className={styles.card2} key={index}>
              <div className={styles.mobileW}>
                <h1 className={styles.name2}>
                  {value.name}
                </h1>
                <p className={styles.des2}>
                  {value.des}
                </p>
                <div className={styles.stars}>
                  <img src={stars} alt="Stars"  />
                </div>
                <div className={styles.center}>
                  <img src={cont} alt={value.rname} className={styles.rimage}/>
                  <div>
                    <h1 className={styles.rname}>{value.rname}</h1>
                    <p className={styles.rdes}>{value.rdes}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        </div>
      </div>
  );
}
